<div class="container" [ngStyle]="{ 'background': trip ? 'transparent' : 'inherit' }" [ngClass]="{'show': showSpinner}">
  <div class="lds-ripple"> 
    <div></div>
    <div></div>
  </div>
</div>